import { render } from "./EmpinactiveList.vue?vue&type=template&id=c3ef5006"
import script from "./EmpinactiveList.vue?vue&type=script&lang=js"
export * from "./EmpinactiveList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__